import styled from 'styled-components';
import { Button } from '@/components/Button';
import { Link } from '@/components/Link';
import type { PurchaseActionType } from '@/types';
import { PurchaseAction } from '@/constants';

const getBackgroundColor = (purchaseAction: PurchaseActionType) => {
  if (purchaseAction === PurchaseAction.BackOrder) {
    return 'var(--blue-light-300)';
  }

  if (purchaseAction === PurchaseAction.Notify) {
    return 'var(--purple-600)';
  }

  if (purchaseAction === PurchaseAction.PreOrder) {
    return 'var(--pink-700)';
  }

  return 'var(--brand-500)';
};

const getForegroundColor = (purchaseAction: PurchaseActionType) => {
  if (
    purchaseAction === PurchaseAction.Notify ||
    purchaseAction === PurchaseAction.PreOrder
  ) {
    return 'var(--white)';
  }

  return 'var(--black)';
};

export const ProductWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  gap: var(--spacing-xsmall);
  width: 100%;
  height: 100%;
  padding-inline: var(--spacing-xsmall);
  border-radius: var(--radius-large);
`;

export const InnerWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: var(--spacing-base);
`;

export const ImageLinkWrapper = styled.div`
  width: 100%;
  position: relative;
  container-type: inline-size;
  flex: 1 0 92px;

  & img {
    width: 100%;
  }
`;

export const ImageLink = styled(Link)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 92px;
  min-width: 92px;
  height: 75px;
  padding: var(--spacing-xsmall);
  background: var(--grey-50);
  border: 1px solid var(--grey-200);
  border-radius: var(--radius-base);

  &:focus-visible {
    box-shadow: var(--shadow-focus);
    border: 1px solid var(--brand-600);
    outline: 0;
  }

  & img {
    object-fit: contain;
    max-width: 100%;
    max-height: 100%;
    box-shadow: 0 0 10px 2px rgb(0 0 0 / 25%);
  }
`;

export const ProdLink = styled(Link)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 4px;
  width: 100%;
  padding: var(--spacing-small);
  text-decoration: none;
  color: var(--black);
`;

export const Title = styled.div`
  font-size: var(--font-size-text-md);
  font-weight: var(--font-weight-bold);
  line-height: 20px;
`;

export const ByLine = styled.div`
  font-size: var(--font-size-text-md);
  font-weight: var(--font-weight-regular);
  line-height: 20px;
  color: var(--grey-500);
`;

export const Format = styled.div`
  font-size: var(--font-size-text-sm);
  font-weight: var(--font-weight-regular);
  line-height: 20px;
`;

export const Price = styled.div`
  font-size: var(--font-size-text-sm);
  font-weight: var(--font-weight-regular);
  line-height: 20px;
`;

export const Cta = styled(Button)<{
  $purchaseAction: PurchaseActionType;
}>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 186px;
  height: 44px;
  margin-inline-start: 116px;
  background: ${props => getBackgroundColor(props.$purchaseAction)};
  box-shadow: 0 1px 2px 0 rgba(10, 13, 18, 0.05);
  color: ${props => getForegroundColor(props.$purchaseAction)};

  &[data-hovered] {
    background: var(--blue-light-400);
    box-shadow: 0 0 0 4px var(--blue-light-100), 0 1px 2px 0 rgb(10 13 18 / 0.05);
  }
`;
